export default {
  pricing: 'Fijación de precios',
  profit: 'Beneficio',
  netPrice: 'Precio de coste',
  supplierOldPrice: 'Precio anterior del proveedor',
  percentageProfit: '% Beneficio',
  grossPrice: 'Precio de venta',
  dates: 'Fechas',
  supplierTypeTotal: '{supplierType} total',
  updatePriceTitle: 'Actualizar precio total',
  updatePriceText: 'El total \'{ newTotal }\' no coincide con su antiguo valor \'{ initialValue }\'. Si cambias este total, ten en cuenta que los precios de los recursos cambiarán para coincidir. ¿Seguro que quieres hacerlo?',
  updateTotalPriceText: 'El total \'{ newTotal }\' no coincide con su antiguo valor \'{ initialValue }\'. Si modifica este total, tenga en cuenta que el precio del recorrido cambiará pero los precios de los productos seguirán siendo los mismos. Si modifica el precio de algún producto, el total se recalculará en función de los precios de los productos. ¿Está seguro de que desea hacerlo?',
  total: 'Total',
  quotePrice: 'Precio de cotización',
  newInvoice: 'Nueva factura',
  invoiceDetail: 'Proveedores',
  invoiceTooltip: 'Integración con software de contabilidad',
  confirmInvoiceMessage: 'Enviará los costes de los proveedores al software de contabilidad',
  confirmInvoiceMessageWithZeroSuppliers: '\"{ zero }\" de \"{ total }\" sproveedores seleccionados tienen un precio de 0. { message }',
  confirmMessage: '¿Estás segura de que quieres continuar esto?',
  integretedHolded: "Integrada en Holded",
  invoice: {
    noResourcesSelectedMessage: 'Seleccione un producto para crear una factura',
    createNew: 'Crear nueva factura emitida',
    basicInformation: 'Información básica',
    number: 'Número de factura',
    amount: 'Importe',
    address: 'Dirección',
    resource: 'Recurso',
    resources: 'Recursos',
    status: 'Estado',
    idIdentity: 'NIF',
    vat: 'Número de IVA',
    type: 'Tipo',
    currency: 'Moneda',
    invoiceName: "Nombre de la factura",
    summary: 'Resumen de la factura',
    total: 'Factura total seleccionada',
    name: 'Nombre',
    date: 'Fecha',
    price: 'Precio',
    invoiceInTotal: 'Factura en total ?',
    clientEmail: 'Client Email',
    clientName: 'Client Name',
  },
  nights: 'Noches',
  dayNumber: 'Número de día',
  dayNumberShort: 'Nº día',
  quantity: 'Cantidad',
  quantityShort: 'Cant.',
  splitPayment: 'Pago dividido',
  resetPriceTitle: 'Restablecer precio',
  resetPriceInfo: '¿Estás segura de que quieres restablecer el precio?'
};
